export default __webpack_public_path__ + "static/media/github.7735eca2.png";